import { reactive } from 'vue';

export const criarAnexoUpload = () => {
  return reactive({
    id: 0,
    idanexogrupo: 0,
    idep: 0,
    idsim: 0,
    idtpdoc: 0,
    idestabelecimento: 0,
    nmdoc: '',
    dhpostagem: '',
    idupostagem: 0,
    obspostagem: '',
    dtvalidade: '',
    fname: '',
    tipo: '',
    origem_sistema: 'SGSIM-WEB',
    origem_versao: '1.25.0514',
    anexo: '',
    idlogin: 0,
    idusuario: 0
  });
};